import { mockResponse } from '@/utils/format'

export function getOverviewData() {
  return mockResponse({
    summaryCards: [
      { key: 'electricity', title: '用电量', today: 65355.22, annual: 10159.13, unit: 'kWh', annualUnit: 'MW', icon: 'el-icon-lightning', color: '#409EFF' },
      { key: 'gas', title: '用天然气量', today: 579.23, annual: 102000.12, unit: 'm³', annualUnit: 'm³', icon: 'el-icon-wind-power', color: '#67C23A' },
      { key: 'oil', title: '用油量', today: 1740.23, annual: 1032000.12, unit: 'kg', annualUnit: 'kg', icon: 'el-icon-truck', color: '#E6A23C' },
      { key: 'water', title: '用水量', today: 488.66, annual: 132317.43, unit: 'm³', annualUnit: 'm³', icon: 'el-icon-cold-drink', color: '#909399' },
      { key: 'pv', title: '光伏发电量', today: 2388.23, annual: 432000.12, unit: 'kWh', annualUnit: 'kWh', icon: 'el-icon-sunny', color: '#F56C6C' },
      { key: 'grid', title: '上网电量', today: 150.41, annual: 10151.35, unit: 'kWh', annualUnit: 'kWh', icon: 'el-icon-upload2', color: '#409EFF' }
    ],
    lastUpdated: '2025-07-07 10:30:00',
    sceneNodes: [
      { name: '电网', icon: 'el-icon-lightning', top: '22%', left: '18%' },
      { name: '光伏', icon: 'el-icon-sunny', top: '20%', left: '78%' },
      { name: '储能', icon: 'el-icon-coin', top: '72%', left: '22%' },
      { name: '天然气', icon: 'el-icon-wind-power', top: '68%', left: '76%' },
      { name: '用水', icon: 'el-icon-cold-drink', top: '45%', left: '10%' },
      { name: '用热', icon: 'el-icon-s-opportunity', top: '50%', left: '88%' }
    ],
    sceneLabels: [
      { label: '当前电量', value: '80 kWh (80%)', top: '32%', left: '38%' },
      { label: '当前温度', value: '55°C', top: '58%', left: '62%', align: 'right' },
      { label: '实时功率', value: '2433.25 kWh', top: '42%', left: '55%' },
      { label: '光伏发电', value: '2388.23 kWh', top: '28%', left: '65%' },
      { label: '储能状态', value: '充电中 92%', top: '65%', left: '42%' }
    ],
    realtimeMonitor: {
      locations: ['4号厂区/总电表', '1号厂区/总电表', '2号厂区/总电表'],
      currentLocation: '4号厂区/总电表',
      total: 25,
      online: 24,
      offline: 1,
      currentValue: 2433.25,
      trend: [2100, 2150, 2200, 2280, 2350, 2400, 2433]
    },
    energyCurve: {
      times: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00'],
      values: [1200, 980, 850, 1100, 2800, 4200, 3800]
    },
    strategyList: [
      { id: 1, title: '清洁能源占比分析', desc: '清洁能源占比达到 32.5%，较上月提升 2.1%', time: '2025-07-07 09:00' },
      { id: 2, title: '峰谷用电优化', desc: '峰段用电占比 28.3%，谷段占比 41.2%', time: '2025-07-07 08:30' },
      { id: 3, title: '设备能效监测', desc: '3 台设备能效低于基准值，建议检修', time: '2025-07-07 08:00' },
      { id: 4, title: '碳排放强度', desc: '单位产值碳排放 0.85 tCO2e/万元', time: '2025-07-07 07:30' }
    ]
  })
}
